import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter, BusinessServiceGroupFilter } from '../../filters';
import BusinessServiceListPanel from '../../panels/business-service-list-panel/BusinessServiceListPanel';

export const pageId = 'business-services';

export default function BusinessServicesPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Business Services`}>
                <FilterContainer>
                    <BusinessServiceGroupFilter />
                    <TimeRangeFilter required />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <BusinessServiceListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
